import React, { Component } from 'react';
import { GET_LIST, AppBarMobile } from 'admin-on-rest';
import withWidth from 'material-ui/utils/withWidth';
import restClient from '../restClient';

import ReviewsList from './ReviewsList';
import AdminlogList from './AdminlogList';
import PendingAdsList from './PendingAdsList';
import AggregatesReport from './AggregatesReport';
import LatestBidsList from './LatestBidsList';

const styles = {
    page:        { padding: '20px 28px 60px', maxWidth: 1280, margin: '0 auto', color: '#1f2937' },
    section:     { marginTop: 24 },
    sectionHead: { display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 10 },
    sectionLabel:{ fontSize: 11, fontWeight: 700, letterSpacing: 0.7, color: '#6b7280', textTransform: 'uppercase' },
    sectionRule: { flex: 1, height: 1, background: '#e5e7eb' },
    grid2:       { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: 16 },
};

class Dashboard extends Component {
    state = {};

    getReportAggregates = () => {
        restClient(GET_LIST, 'admin/clicks_report_aggregates', {
            filter: {}, sort: {}, response_single: true, pagination: { page: 1, perPage: 100 },
        }).then((response) => response.data).then((aggregatesReport) => this.setState({ aggregatesReport }));
    };

    componentDidMount() {
        restClient(GET_LIST, 'public/lastten', { filter: {}, sort: {}, pagination: { page: 1, perPage: 100 } })
            .then((r) => r.data).then((reviewsList) => this.setState({ reviewsList }));

        restClient(GET_LIST, 'admin/newerrorlog', { filter: {}, sort: {}, pagination: { page: 1, perPage: 100 } })
            .then((r) => r.data).then((newerrorLogs) => this.setState({ newerrorLogs }));

        restClient(GET_LIST, 'admin/ad', { filter: { ad_status: 'In afwachting van goedkeuring' }, sort: {}, pagination: { page: 1, perPage: 100 } })
            .then((r) => r.data).then((pendingAds) => this.setState({ pendingAds }));

        restClient(GET_LIST, 'admin/latestbidhistory', { filter: {}, sort: {}, pagination: { page: 1, perPage: 100 } })
            .then((r) => r.data).then((latestBids) => this.setState({ latestBids }));

        restClient('DELETE_ALL', 'admin/ipblacklist_expires', { filter: {}, sort: {}, pagination: { page: 1, perPage: 100 } })
            .then((r) => r.data);

        this.getReportAggregates();
        this.interval = setInterval(this.getReportAggregates, 180000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { reviewsList, aggregatesReport, pendingAds, newerrorLogs, latestBids } = this.state;
        const { width } = this.props;

        return (
            <div style={styles.page}>
                {width === 1 && <AppBarMobile title="Cloudhints - Admin portal" />}

                <div style={styles.sectionHead}>
                    <span style={styles.sectionLabel}>Statistieken</span>
                    <span style={styles.sectionRule} />
                </div>
                <AggregatesReport reports={aggregatesReport} />

                <div style={styles.section}>
                    <div style={styles.sectionHead}>
                        <span style={styles.sectionLabel}>Te doen</span>
                        <span style={styles.sectionRule} />
                    </div>
                    <div style={styles.grid2}>
                        <PendingAdsList nb="Goed te keuren ads" ads={pendingAds} />
                        <AdminlogList nb="Nieuwe meldingen" logs={newerrorLogs} />
                    </div>
                </div>

                <div style={styles.section}>
                    <div style={styles.sectionHead}>
                        <span style={styles.sectionLabel}>Activiteit</span>
                        <span style={styles.sectionRule} />
                    </div>
                    <div style={styles.grid2}>
                        <LatestBidsList nb="Laatste bid changes" bids={latestBids} />
                        <ReviewsList nb="Recente reviews" reviews={reviewsList} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withWidth()(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js